<template>
  <div class="order-items-table-row" :class="{accepted: orderItemAccepted, declined: orderItemDeclined}">
    <div class="order-items-table-row-left">
      <div class="single-order-card-label">Item no:</div>
      <div>{{ orderItemNumber }}</div>
      <div class="row items-center no-wrap justify-between pr-2">
        <b-icon-exclamation :id="`order-item-p-warn-${orderItem.id}`" style="width: 28px; height: 28px" variant="danger" class="mr-1"/>
        <b-tooltip :target="`order-item-p-warn-${orderItem.id}`" variant="danger">
          {{ itemPackagesDanger }}
        </b-tooltip>
        <b-btn
            v-if="orderItem.product_id && !orderItem.is_declined"
            color="info"
            flat
            dense
            size="xs"
            no-caps
            @click.prevent="showPackages = !showPackages"
        >
          {{ orderItem.packages.length ? 'Show Packages' : 'No Packages' }}
          <b-icon-chevron-up v-if="showPackages"/>
          <b-icon-chevron-down v-else/>
        </b-btn>
      </div>
    </div>
    <div class="order-items-table-row-product">
      <div class="row">
        <b-img
            v-if="orderItem.image_url"
            :src="orderItem.image_url"
            :alt="orderItem.name"
            no-spinner
            width="60px"
            class="order-items-table-row-product-image"
        />
        <div>
          <div class="order-items-table-row-product-name">{{ orderItem.name }}</div>
          <div v-if="orderItem.category_type">
            Product Line:
            <div>
              {{ orderItem.category_type ? orderItem.category_type.name : '' }} {{ orderItem.category ? orderItem.category.name : '' }}
            </div>
          </div>
        </div>
      </div>
      <span v-if="!item.product_id" class="mt-2 text-danger">No Product</span>
    </div>
    <div class="order-items-table-row-brand">
      {{ orderItem.brand ? orderItem.brand.name : '' }}
    </div>
    <div class="order-items-table-row-qty">
      {{ getFormattedQty(orderItem.inventory_value, orderItem.inventory_unit) }}
    </div>
    <div class="order-items-table-row-unit-price">
      {{ getFormattedPrice(orderItem.unit_price) }}
    </div>
    <div class="order-items-table-row-total-price">
      {{ getFormattedPrice(orderItem.total_price) }}
    </div>
    <div class="order-items-table-row-notes">
      <template v-if="orderItem.notes">
        <div class="single-order-card-label">Item Note:</div>
        {{ orderItemNotes }}{{ orderItemNotesHasMore ? '...' : '' }}
        <template v-if="orderItemNotesHasMore">
          <a href="#" class="text-green no-decoration" @click.prevent="fullNotes = true">More</a>
        </template>

      </template>

    </div>
    <div class="order-items-table-row-actions">
      <span v-if="orderItem.is_accepted" class="text-primary">ACCEPTED</span>
      <span v-else-if="orderItem.is_declined" class="text-negative">
        DECLINED
        <b-icon-info-circle-fill id="fees-info-icon" style="width: 26px; height: 26px;" variant="danger"/>
        <b-tooltip target="fees-info-icon">
          <ul class="px-2 py-2 mb-0" style="list-style-type: none">
            <li v-for="(reason, key) in declinedItemReasons" :key="key">
              <div v-if="reason.title">{{ reason.title }}</div>
              <div>{{ reason.text }}</div>
              <hr>
            </li>
          </ul>
        </b-tooltip>
      </span>
    </div>
    <div class="order-items-table-row-divider"/>
    <div v-show="showPackages" class="order-items-table-row-packages">
      <div class="packages-main">

        <table v-if="orderItem.packages.length > 0">
          <thead>
          <tr>
            <th>Source Package</th>
            <th class="pl-4">Qty</th>
            <th></th>
            <th>Package Price</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(itemPackage, key) in orderItem.packages"
              :key="key"
          >
            <td>
              <div class="row items-center no-wrap">
                <div>{{ itemPackage.tag }}</div>
              </div>
            </td>
            <td>
              <div class="pl-4">
                {{ getFormattedQty( itemPackage.inventory_value, itemPackage.inventory_unit ) }}
              </div>
            </td>
            <td>

            </td>
            <td class="py-2">
              <span>{{ getFormattedPrice(itemPackage.price) }}</span>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="mt-4">
          <div :class="{'text-negative': orderItem.packages_qty !== orderItem.inventory_value}">
            <span class="single-order-card-label mt-3">Package Quantity:</span>
            {{ getFormattedQty( orderItem.packages_qty, orderItem.inventory_unit ) }}
          </div>
          <div :class="{'text-negative': orderItem.packages_price !== orderItem.total_price}">
            <span class="single-order-card-label mt-3">Package Price:</span>
            {{ getFormattedPrice( orderItem.packages_price ) }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormattedPrice, getFormattedQty} from "../helpers";

export default {
  name: "AdminOrderItemRow",
  props: {
    order: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    accepted: {
      type: Boolean,
      default: false
    },
    declined: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fullNotes: false,
      showPackages: false,
      packageSearchValue: '',
      metrcPackages: [],
      packageToRemove: null,
      packageRemoveConfirm: false,
      lastPackageRemoveNotification: false,
      packagesLoading: false,
      packagesLoaded: false,
      packageToSplit: null,
      metrcPackageToSplit: null,
      metrcPackageToSplitLoading: false,
      metrcLocations: [],
      metrcItem: null,
      splitPackageFormData: {
        tag: "",
        inventory_value: ""
      },
      itemRemoveConfirm: false
    }
  },
  computed: {
    orderItem() {
      return this.item;
    },
    orderItemNumber() {
      let number = this.index + 1;
      if (number < 10) {
        number = `0${number}`;
      }

      return number;
    },
    orderItemNotes() {
      if (this.fullNotes || !this.item.notes) {
        return this.item.notes;
      }

      return this.item.notes.substring(0, 120);
    },
    orderItemNotesHasMore() {
      return this.item.notes !== this.orderItemNotes;
    },
    orderItemAccepted() {
      return !! this.accepted;
    },
    orderItemDeclined() {
      return !! this.declined;
    },
    orderHasTransfer() {
      return !! this.order.transfer;
    },
    itemPackagesDanger() {
      if (this.orderItem.is_accepted) {
        if (this.orderItem.packages.length === 0) {
          return 'No packages';
        }
        if (this.orderItem.packages_qty !== this.orderItem.inventory_value ||
            this.orderItem.packages_price !== this.orderItem.total_price) {
          return 'Check quantity';
        }
      }
      return false;
    },
    declinedItemReasons() {
      let items = [];

      if (this.orderItem.is_declined) {
        this.orderItem.rejection_reasons.forEach((item) => {
          if ('other' !== item.code) {
            items.push({
              title: item.name,
              text: item.alternative,
            });
          } else {
            items.push({
              text: item.alternative,
            });
          }
        });

        if (null !== this.orderItem.counter_offer_product_name) {
          items.push({
            title: 'Suggested alternative item',
            text: this.orderItem.counter_offer_product_name,
          });
        }
      }

      return items;
    }
  },
  methods: {
    getFormattedQty,
    getFormattedPrice,
    loadMetrcItem() {
      if (this.metrcItem === null) {
        this.$API.METRC_ITEM.GET(this.item.metrc_item_id, {
          license: this.order.license?.id,
        }).then(({ data }) => {
          this.metrcItem = data.item;
        });
      }
    }
  },
  watch: {
    showPackages(show) {
      if (show && ! this.packagesLoaded && ! this.packagesLoading && ! this.orderHasTransfer) {
        this.loadMetrcItem();
      }
    }
  },
  created() {
    if (!this.item.product_id) {
      this.loadMetrcItem();
    }
  }
}
</script>
